import React from 'react';
import { DefaultButton, Panel, PanelType, PrimaryButton } from '@fluentui/react';
import DynamicForm from '../../components/DynamicForm/DynamicForm';
import { IField } from '../../shared/interfaces';
import { Indici_FormMode } from '../../shared/enums';
import CircleLoader from '../../components/Loader/CircleLoader/CircleLoader';

const cloneFields = (fields: IField[]) => fields.map((f) => ({ ...f }));


interface SearchPanelProps {
    isOpen: boolean,
    initialSearchFields: IField[],
    onDismiss: () => void;
    onApply: (fields: IField[]) => void;
    isLoading?: boolean;
    extraCssClass?: string;
}
type Props = SearchPanelProps
const SearchPanel: React.FunctionComponent<Props> = ({
    isOpen,
    initialSearchFields,
    onDismiss,
    onApply,
    isLoading = false
}) => {
    const [searchFormFields, setSearchFormFields] = React.useState<IField[]>(() =>
        cloneFields(initialSearchFields)
    );

    const wasOpenRef = React.useRef(false);

    React.useEffect(() => {
        if (isOpen && !wasOpenRef.current) {
            setSearchFormFields(cloneFields(initialSearchFields));
        }
        wasOpenRef.current = isOpen;
    }, [isOpen, initialSearchFields]);

    const handleFieldChange = (newField: IField) => {
        setSearchFormFields((prev) => {
            const index = prev.findIndex(
                (el) => el.internalName === newField.internalName
            );
            if (index === -1) return prev;

            const next = [...prev];
            next[index] = !newField.internalValue
                ? { ...newField, touched: false }
                : { ...newField };

            return next;
        });
    };

    const handleReset = React.useCallback(() => {
        setSearchFormFields((prev) =>
            prev.map((el) => ({
                ...el,
                internalValue: null,
                touched: false,
            }))
        );
    }, []);

    const handleApply = React.useCallback(() => {
        onApply(searchFormFields);
    }, [onApply, searchFormFields]);

    const renderFooter = React.useCallback(
        () => (
            <>
                <PrimaryButton
                    text="Cerca"
                    onClick={handleApply}
                    styles={{ root: { marginRight: 8 } }}
                />
                <DefaultButton text="Reset filtri" onClick={handleReset} />
            </>
        ),
        [handleApply, handleReset]
    );
    return (

        <React.Fragment>
            <Panel
                isOpen={isOpen}
                isLightDismiss
                type={PanelType.custom}
                customWidth={'600px'}
                headerText={'Filtri di ricerca'}
                closeButtonAriaLabel="Close"
                isHiddenOnDismiss={false}
                onDismiss={onDismiss}
                onRenderFooterContent={renderFooter}
            >
                <div className={`search-form-dialog flex flex-column position-relative`}>

                    <div className={`position-relative my-scroll-div`}>
                        <div style={{ minHeight: '500px' }}>
                            <CircleLoader loaderClass='loader-large' loading={isLoading} />

                            {!isLoading &&
                                <DynamicForm
                                    formMode={Indici_FormMode.Search}
                                    fields={searchFormFields}
                                    onInputChangedHandler={handleFieldChange}
                                />
                            }
                        </div>


                    </div>

                </div>
            </Panel>
        </React.Fragment>

    )
};
export default SearchPanel;


